import { FC, useMemo, ReactNode, memo } from 'react';
import Tooltip, { TooltipProps } from 'antd/lib/tooltip';
import { useTranslation } from 'react-i18next';

interface ItemsI {
  id: string;
  name: string;
}

interface Props extends Omit<TooltipProps, 'title'> {
  items: ItemsI[];
  restCount: number;
  maxPreviewCount?: number;
  moreTextKey?: string;
}

const TooltipList: FC<Props> = memo(props => {
  const {
    items,
    restCount,
    maxPreviewCount = 10,
    moreTextKey = 'x.tooltip_with_items.more_items_text',
    ...tooltipProps
  } = props;
  const [t] = useTranslation();

  const getRestCountStr = (count: number) => (count > 999 ? `${Math.round(count / 1000)}k` : count);

  const tooltipContent = useMemo<ReactNode>(() => {
    const startIndex = items.length - restCount;
    const tooltipLabels = items
      .slice(startIndex, startIndex + maxPreviewCount)
      .map(label => <div key={label.id}>{label.name}</div>);

    if (restCount > maxPreviewCount) {
      tooltipLabels.push(
        // tslint:disable-next-line: jsx-wrap-multiline
        <div key="rest-text" data-translation={moreTextKey}>
          {t(moreTextKey, {
            labelCount: getRestCountStr(restCount - maxPreviewCount),
          })}
        </div>,
      );
    }

    return tooltipLabels;
  }, [items]);

  return (
    <Tooltip {...tooltipProps} title={tooltipContent}>
      {props.children}
    </Tooltip>
  );
});

export default TooltipList;
